import { isNumber, isPhoneForCountry, isEmail } from 'common-validator-fif-payments';

const schema = {
  email: {
    type: 'text',
    errorMessage: ['errors.email.required', 'errors.email.rules'],
    isValid: [(value) => value.length > 0, (value) => isEmail(value)],
  },
  phone_number: {
    type: 'text',
    errorMessage: ['errors.phone.required', 'errors.phone.onlyNumbers', 'errors.phone.valid'],
    isValid: [
      (value) => value.length > 0,
      (value) => isNumber(value),
      (value) => isPhoneForCountry('cl', `56${value}`),
    ],
  },
};

export default schema;
